import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, X } from 'lucide-react';

export default function StickyConsultation() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (!dismissed) setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [dismissed]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  if (dismissed) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-consultation"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-6 left-6 z-50 flex items-center gap-3 px-5 py-3 rounded-full shadow-xl border"
          style={{
            background: 'linear-gradient(135deg, var(--color-secondary), var(--color-accent))',
            borderColor: 'rgba(255,255,255,0.1)',
          }}
        >
          <Phone size={16} className="text-white animate-glow-pulse" />
          <button
            onClick={() => scrollTo('contact')}
            data-testid="sticky-consultation-button"
            className="text-white font-body text-sm font-semibold whitespace-nowrap"
          >
            Free Consultation
          </button>
          <button
            onClick={() => setDismissed(true)}
            data-testid="sticky-consultation-dismiss"
            className="text-white/60 hover:text-white ml-1 transition-colors"
            aria-label="Dismiss consultation banner"
          >
            <X size={14} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
